<template>
    <div class="pt-3 pb-5">
        <data-table ref="municipalities"
                    :api-route="backendApiRoute"
                    :api-view-set="table.apiViewSet"
                    :name="table.name"
                    :columns="table.columns"
                    :search="table.search"
                    :filters="table.filters ? table.filters : []"
                    :actions="table.actions"
                    :orderings="table.orderings"
                    :initial-orderings="table.initialOrderings"
                    :row-actions="table.rowActions"
                    :key="table.key"
                    :destroy-title="'Удаление муниципалитета'">
        </data-table>
    </div>
</template>

<script>
    import DataTable from "../../../../components/Table/DataTable";
    import {mapGetters} from "vuex";
    import api from "../../../../api";
    import actions, {AvailableAction} from "@/components/Table/actions";
    import { Municipality } from "@/pages/AppPages/Catalogs/Municipality/municipality";

    export default {
        name: "MunicipalityList",
        components: { DataTable },
        computed: {
            ...mapGetters(['ability', 'isSuperuser']),
            backendApiRoute() { return api.municipalities.default.list() },
            canCreate() {
                if (this.isSuperuser) return true;
                return this.ability.can('create', 'Municipality')
            },
        },
        data() {

            return {
                table: {
                    name: 'municipalities-table',
                    apiViewSet: api.municipalities.default,
                    key: 'municipalities-table',
                    search: true,
                    columns: [
                        {
                            name: 'short_name',
                            title:  'Название',
                            alwaysVisible: true,
                            to: {
                                idColumn: 'id',
                                routeName: 'municipalityDetail',
                                prependWithN: false
                            }
                        },
                        { name: 'parent_name', title: 'Вышестоящий муниципалитет' },
                        { name: 'active', 'title': 'Активен',
                            cellComponentName: 'BooleanCell',
                            cellComponentPath: 'src/pages/DataTableCells/'},
                        { name: 'list_order', title: 'Порядковый номер' },
                    ],
                    orderings: [
                        'name',
                        {'active': 'eliminated'},
                        {'parent_name': 'parent'},
                        'list_order'
                    ],
                    actions: [],
                    rowActions: [],
                    filters: [
                        {
                            title: 'Вышестоящий муниципалитет',
                            name: 'parent', label: 'parent',
                            initialFilters: [ {'key': 'has_children', 'value': 1}, ],
                            source: api.municipalities.default.list(),
                            labelKey: 'short_name',
                            hasSearch: true
                        },
                        {
                            title: 'Активен',
                            name: 'is_active', label: 'is_active', type: 'boolean'
                        },
                    ]
                }
            }
        },
        mounted() {
            if (this.canCreate) {
                this.table.actions.push(
                    actions.create(() => {
                            this.$router.push({name: 'municipalityCreate'})
                        }, this.canCreate
                    )
                );
            }

            if (this.ability.can('destroy', 'Municipality')) {
                this.table.rowActions.push(
                    new actions.objectDelete(Municipality))
            }
        }
    }
</script>

<style scoped>

</style>